import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _ByDepreciationValue, _DepreciationQuota, _DepreciationTime, _FixedAssetItemsWithDefeatDates, _QuotaUpdateForItems, _RecalculateDepreciation } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../core/services/Singleton";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectFixedAsset } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { SelectStoreEditor } from "../../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import { FileInput } from "../../../../theme/Component/FileInput";
import { AccountantYear } from "../ProductionPlan/AccountantYear";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";


export const ByDepreciationValue = () => {

    const ByDepreciationValue = useDataBean(_ByDepreciationValue);
    const imp = useDataBean(_QuotaUpdateForItems);
    const time = useDataBean(_DepreciationTime);
    const register = useDataBean(_DepreciationQuota);
    const DepreciationValues = useDataBean(_RecalculateDepreciation);
    // const employeeContracttofunctional = useDataBean(_FunctionalAreaToEmployee);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [formtwo, setformtwo] = useState<any>({
        Name: null,
        asset: null,
        placa: null
    })
    const [form, setForm] = useState<any>({
        Media: NaN,
        MediaContext: NaN,
        Year: _single.getCurrenYear(),
        Month: NaN,

    })
    const [storeID, setstoreID] = useState<number>(null)
    const [Account, setAccount] = useState<any>(null);
    const [date, setdate] = useState<any>(_single.getCurrenDate());
    const [fixed, setfixed] = useState<any>(null);
    const [state, setstate] = useState<any>(null);
    const [employetype, setemployetype] = useState<any>(null);
    const [functional, setFuntional] = useState<any>(null);
    const [IDLnSiteID, setIDLnSiteID] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [defeatmin, setdefeatmin] = useState<any>(80);
    const [defeatmax, setdefeatmax] = useState<any>(100);
    const [Fornight, setFornight] = useState<any>(null);
    const [NameList, setNamelist] = useState<any>(null);
    const [Appointment, setAppointment] = useState<any>(null);
    const [modaltime, setModaltime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalregis, setModalregis] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [EntailmentName, setEntailmentName] = useState<any>(null);
    const [records, setRecords] = useState<number>(15);
    const [modaldefinirplaza, setModaldefinirplaza] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        ByDepreciationValue.instance.getFixedAssetItemsByDepreciationValue(defeatmin, defeatmax, formtwo.asset, regexStr, Account, storeID, state, paginador.page, 15).then(
            (resp) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        )
    }

    const head = [
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Elemento', property: 'Name', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Vr Unitario', property: 'UnitaryValue', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: '(+)Adiciónes', property: 'DepreciationAddition', visible: true },
        { title: '(+)Adición Inicial', property: 'NiifAdditionValue', visible: true },
        { title: '(+)Vr Reconocimiento NIIF', property: 'NiifInitialValue', visible: true },
        { title: '(+)Valorizaciones', property: 'DepreciationRevaluation', visible: true },
        { title: '(-)Desvalorizaciones', property: 'DepreciationDevaluation', visible: true },
        { title: '(-)Deterioro', property: 'DepreciationDeterioration', visible: true },
        { title: '(-)Vr Residual', property: 'ResidualValue', visible: true },
        { title: 'Vr Histórico (Base)', property: 'DepreciationBase', visible: true },
        { title: 'Vr Depreciado', property: 'DepreciationValue', visible: true },
        { title: '% Depreciado', property: 'DepreciationPercent', visible: true },
        { title: 'Última Depreciación', property: 'DepreciationLastDate', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Doc', property: 'Mnemonic', visible: true },
        { title: 'Num Doc', property: 'Consecutive', visible: true },

    ]

    const recalculateDepreciationValues = () => {
        DepreciationValues.instance.recalculateDepreciationValues(null).then(
            (resp) => {
                console.log(resp)
                toast.success('Recalculado')
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const verimp = () => {
        setModalimp({ ...modalimp, "view": true })
    }
    const vertime = () => {
        setModaltime({ ...modaltime, "view": true })
    }
    const verregis = () => {
        setModalregis({ ...modalregis, "view": true })
    }
    const importDepreciationQuotaUpdateForItems = () => {
        imp.instance.importDepreciationQuotaUpdateForItems(imp.bean.Media, imp.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Importado')
                setModalimp({ ...modalimp, "view": false })
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const importDepreciationTimeUpdateForItems = () => {
        time.instance.importDepreciationTimeUpdateForItems(time.bean.Media, time.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Actualizado')
                setModaltime({ ...modaltime, "view": false })
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const importUpdateForDepreciationQuotaCalculated = () => {
        register.instance.importUpdateForDepreciationQuotaCalculated(form.Media, form.MediaContext, null, form.Year, form.Month).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Actualizado')
                setModalregis({ ...modalregis, "view": false })
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const listaBotones = () => {
        const botones = [

            { titulo: '', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaldefinirplaza({ ...modaldefinirplaza, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Alertas de Activos Proximos a Depreciar">

            <div className="row">

                <div className="col-md-4">
                    <label>Porcentaje de Deprciación Mínimo</label>
                    <input type="text" className="form-control" value={defeatmin} onChange={(e) => { setdefeatmin(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <label>Porcentaje de Depreciación Máximo</label>
                    <input type="text" className="form-control" value={defeatmax} onChange={(e) => { setdefeatmax(e.target.value) }} />
                </div>

                <div className="col-md-4">
                    <label>Activo Fijo</label>
                    <SelectFixedAsset render={formtwo.Name} idSelector={formtwo.asset} onChange={(e) => { setformtwo({ ...formtwo, "asset": e.IDFixedAsset, "Name": e.Description }) }} label=" " returnType="Object" />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e) }} label="Proveedor/Responsable" />
                </div>
                <div className="col-md-4">
                    <SelectStoreEditor label='Almacén/Bodega' idSelector={storeID} onChange={(e) => { setstoreID(e.IDStore) }} />
                </div>
                <div className="col-md-4">
                    <label>Estado Lista:</label>
                    <select className="form-control" value={state} onChange={(e: any) => { setstate(e.target.value) }} >
                        <option value={NaN}>...</option>
                        <option value={0}>ITEM_AVAILABLE</option>
                        <option value={1}>ITEM_IN_USE</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6 mt-3">
                    <BasicButton icon="ri-send-plane-fill" eventClick={verimp}>Actualizar Valores de Cuota de Depreciación Mensual</BasicButton>
                </div>
                <div className="col-md-6 mt-3">
                    <BasicButton icon="ri-bar-chart-grouped-line" eventClick={verregis}>Actualizar Valores Registrados de Depreciación Mensual</BasicButton>
                </div>

                <div className="col-md-5 mt-3">
                    <BasicButton icon="ri-bar-chart-grouped-fill" eventClick={recalculateDepreciationValues}>Actualizar Porcentajes de Depreciación</BasicButton>
                </div>
                <div className="col-md-5 mt-3">
                    <BasicButton icon="ri-bar-chart-grouped-fill" eventClick={vertime}>Actualizar Valores de Tiempo Mensual de Depreciación</BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={ByDepreciationValue.setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}
                    />
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importDepreciationQuotaUpdateForItems}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <FileInput
                                        label='Archivo a importar'
                                        directory='ImpoFactorSalarial'
                                        onCreate={({ Media, MediaContext }) => { imp.setBean({ ...imp.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                    />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modaltime} updateModal={setModaltime} eventModal={importDepreciationTimeUpdateForItems}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <FileInput
                                        label='Archivo a importar'
                                        directory='timeupdate'
                                        onCreate={({ Media, MediaContext }) => { time.setBean({ ...time.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                    />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalregis} updateModal={setModalregis} eventModal={importUpdateForDepreciationQuotaCalculated}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <FileInput
                                        label='Archivo a importar'
                                        directory='registro'
                                        onCreate={({ Media, MediaContext }) => { setForm({ ...form, "Media": Media, "MediaContext": MediaContext }) }}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <AccountantYear idSelector={form.Year} onChange={(e: any) => { setForm({ ...form, "Year": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <MonthConstantsEditor idSelect={form.Month} onChange={(e: any) => { setForm({ ...form, "Month": e }) }} label="Mes" />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}